import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { getTaxFilingSchemas } from "../utils/validation/taxFilingValidation";

export default function useTaxFilingValidation({
  service,
  schemaKey,
  defaultValues,
}) {
  const { completeSchema } = useMemo(() => {
    return getTaxFilingSchemas({ service, schemaKey });
  }, [service, schemaKey]);

  const formMethods = useForm({
    resolver: zodResolver(completeSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: defaultValues || {},
  });

  return { formMethods };
}
